export const resolveHomeReturnTo = (currentUrl: URL): string => {
  const returnPath: string | null = currentUrl.searchParams.get('return_to');
  const safeReturnPath: string =
    returnPath?.startsWith('/') && !returnPath.startsWith('//') ? returnPath : '/';
  return new URL(safeReturnPath, currentUrl.origin).toString();
};
